module.exports = __webpack_public_path__ + "media/images/icon-profile-big@3x-252f17b44cf0e6eec27ebf26e56b9463.png";